<dx-data-grid id="gridContainer"
              [dataSource]="dataSource"
              [showRowLines]="true"
              [showColumnLines]="false"
              [showBorders]="true"
              [allowColumnResizing]="true"
              (onSelectionChanged)="onSelectionChanged($event)"
              (onCellHoverChanged)="onCellHoverChanged($event)">
  <dxo-selection mode="single"></dxo-selection>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-paging [pageSize]="10"> </dxo-paging>
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxi-column caption="" width="50px" cellTemplate="thumbNailTemplate"></dxi-column>
  <dxi-column [caption]="labels.Name" [calculateCellValue]="sortByName" width="30%" [allowSorting]="true" cellTemplate="documentTemplate"></dxi-column>
  <dxi-column [caption]="labels.number" dataField="Number"></dxi-column>
  <dxi-column [caption]="labels.Type" [allowSorting]="true" dataField="TypeDetail"></dxi-column>
  <dxi-column [caption]="labels.Category" [allowSorting]="true" dataField="CategoryDetail"></dxi-column>
  <dxi-column [caption]="labels.Version" cellTemplate="versionTemplate"></dxi-column>
  <dxi-column [caption]="labels.Codes" cellTemplate="codesTemplate"></dxi-column>

  <div *dxTemplate="let d of 'documentTemplate'">
    <div>{{ d.data.DocumentDetails?.line3 }}</div>
    <div>{{ d.data.DocumentDetails?.line2 }}</div>
    <dx-popover [(target)]="popoverTarget"
                position="bottom"
                [width]="400"
                [(visible)]="popoverVisible">
      <div *dxTemplate="let data of 'content'">{{ popoverText }}</div>
    </dx-popover>
  </div>

  <div *dxTemplate="let d of 'versionTemplate'">
    <div>{{ d.data.VersionDetails?.line1 | slice:0:15 }}</div>
    <div>{{ d.data.VersionDetails?.line2 | slice:0:15 }}</div>
  </div>

  <div *dxTemplate="let d of 'codesTemplate'">
    <div>{{ d.data.CodeDetails?.line1 | slice:0:15 }}</div>
    <div>{{ d.data.CodeDetails?.line2 | slice:0:15 }}</div>
    <div>{{ d.data.CodeDetails?.line3 | slice:0:15  }}</div>
  </div>

  <div *dxTemplate="let d of 'attributtTemplate'">
    <div>{{ d.data.AttributeDetails?.line1 | slice:0:15 }}</div>
    <div>{{ d.data.AttributeDetails?.line2 | slice:0:15 }}</div>
  </div>

  <div *dxTemplate="let d of 'thumbNailTemplate'">
    <div><img #imglogo style="display:table-cell; height: 50px; max-width: 50px; cursor: pointer;" src="{{d.data.ThumbnailDetail}}" /></div>
  </div>

</dx-data-grid>
